import { useEffect, useRef, useState } from 'react';

import { useDebounce } from '@utils/hooks';

const DEBOUNCE_TIME = 500;

const useOverflowGap = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const ref = useRef<HTMLDivElement>(null);

  const [gap, setGap] = useState(0);
  const debounced = useDebounce(DEBOUNCE_TIME);

  useEffect(() => {
    const callback = () => {
      const wrapperWidth = wrapperRef.current?.getBoundingClientRect().width || 0;
      const contentWidth = ref.current?.getBoundingClientRect().width || 0;
      setGap(contentWidth > wrapperWidth ? contentWidth - wrapperWidth : 0);
    };

    callback();

    const resizeObserver = new ResizeObserver(() => {
      debounced(callback);
    });

    if (wrapperRef.current && ref.current) {
      resizeObserver.observe(wrapperRef.current);
      resizeObserver.observe(ref.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return [wrapperRef, ref, gap] as const;
};

export default useOverflowGap;
